<mat-card appearance="outlined">
    <div class="image-wrapper">
        <img mat-card-image [src]="props?.imagePath" [alt]="props?.label + ' spotlight image'" />
    </div>
    <div class="header">
        <p class="tag" [ngClass]="props?.svgIcon">{{ props?.label }}</p>
        <p class="title"><mat-icon [svgIcon]="props?.svgIcon" aria-hidden></mat-icon>{{ props?.label }}</p>
    </div>
    <mat-card-content>
        <p class="ellipsis-4">{{ props?.description }} </p>
    </mat-card-content>
    <mat-card-actions>
        <a
            [routerLink]="'/' + props?.route"
            [matTooltip]="'Visit the ' + props?.label + ' page'"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000">
            <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
        </a>
    </mat-card-actions>
</mat-card>
